import splunk from "../../../../common/splunk";
import { getCommonSplunkData, isElementInViewport } from "./utils";

export const sendVideoSplunkEvent = (
  videoElementRef,
  eventType,
  eventName,
  params = {},
  config = {}
) => {
  if (!videoElementRef?.current) return;

  const { debug = false } = config;

  const isProd = process.env.NODE_ENV === "production";

  const commonSplunkData = getCommonSplunkData(eventType, config);

  const splunkData = {
    ...commonSplunkData,
    isElementInViewport: isElementInViewport(videoElementRef.current),
    videoId: videoElementRef.current.id,
    ...params
  };

  // We only want to record events from prod environments
  if (isProd) {
    splunk.send(eventName, splunkData);
  }

  if (debug) {
    console.log(
      `${isProd ? "" : `Mock`} Splunk event sent: ${eventName}. Video: ${
        videoElementRef.current.id
      }`,
      splunkData
    );
  }
};
